import React from 'react'
import { CarouselAPI } from '../../../../constructs/carousel/interface'
import { useAPIContext } from '../../context/api'

export const useVideoHistory = () => {
  const { callEndpoint } = useAPIContext()

  const fetchVideos = React.useCallback(async (widgetId: string) => {
    try {
      const response = await callEndpoint<CarouselAPI, 'list-videos'>('carousel', `/videos/${widgetId}`, 'GET')
      return response || []
    } catch (err) {
      console.error('API Error:', err)
    }
  }, [callEndpoint])

  return { fetchVideos }
}
